import React from 'react';
import PropTypes from 'prop-types';
import { ForgePaginator } from '@tylertech/forge-react';

const PaginationWrapper = ({ totalCount, pageSize, currentPage, handleChange, pageSizeOptions, topDivider }) => {

  return (
    <div className={topDivider ? 'borderTop' : ''} style={{ width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
      <ForgePaginator
        style={{ width: 'fit-content' }}
        firstLast
        total={totalCount}
        pageSize={pageSize}
        pageIndex={currentPage}
        pageSizeOptions={pageSizeOptions}
        on-forge-paginator-change={(e) => handleChange(e)}
      />
    </div>
  );
};

PaginationWrapper.propTypes = {
  totalCount: PropTypes.number,
  pageSize: PropTypes.number,
  currentPage: PropTypes.number,
  handleChange: PropTypes.func,
  topDivider: PropTypes.bool,
  pageSizeOptions: PropTypes.arrayOf(PropTypes.number),
};

export default PaginationWrapper;
